import { LevelPool } from '@trustpad/launchpad';

import { Popup } from '~common/components/Popup';

const BoosterItem = ({ value, label }) => (
  <div className="text-center flex-shrink-0">
    <div className={`${value > 0 ? 'brand-text' : 'text-gray-600'} text-3xl`}>
      +{value}%
    </div>
    <div className="secondary-text leading-none text-sm">{label}</div>
  </div>
);

export function StakingPoolAllocationBoosters({
  config,
}: {
  config: LevelPool;
}) {
  return (
    <div className="">
      <div className="text-center">
        <h5 className="text-gray-100 text-lg text-center inline-block">
          🚀 Allocation Boosters
        </h5>
        <Popup containerClassName="ml-2" header="Allocation Boosters">
          <p>
            In the 30-day and longer-period staking pools there is a multiplier
            that will give you an extra allocation according to your staking
            duration and Echelon (Guaranteed, All-Access Guaranteed – AAG, or
            Super All-Access Guaranteed – SAAG).
          </p>
          <p>
            If you stake so that your allocation booster is +390% i.e. 4.9× and
            your level is Associate - 15×, then your effective multiplier is 15
            × 4.9 = 73.5×. Then if the base allocation in an IDO is $15, the
            amount you can purchase is 73.5 x $15 = $1102.50
          </p>
        </Popup>
      </div>

      <div className="flex justify-around flex-wrap gap-8">
        <BoosterItem
          label="Guaranteed"
          value={config.boosters?.guaranteed ?? 0}
        />
        <BoosterItem label="AAG" value={config.boosters?.aag ?? 0} />
        <BoosterItem label="SAAG" value={config.boosters?.saag ?? 0} />
      </div>
    </div>
  );
}
